import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'notifications',
            name: 'notification',
            class: 'App\\Models\\Notification'
        }
    },

    methods: {
        prepareResource(resource) {
            switch (resource.data.type) {
                case 'ContactForm':
                    resource.custom_component_1 = {
                        component: 'contact-form-data'
                    }
                break;

                case 'ProjectContactForm':
                    resource.custom_component_1 = {
                        component: 'project-contact-form-data'
                    }
                break;
            }
        }
    }
}